var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundDailyPointsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C9.49957 1 7.07374 1.85189 5.12233 3.41527C3.17092 4.97864 1.81037 7.16021 1.26492 9.60043C0.719463 12.0406 1.02166 14.5939 2.1217 16.8393C3.22174 19.0848 5.05397 20.8885 7.31643 21.9531C9.57889 23.0177 12.1366 23.2798 14.5679 22.6961C16.9992 22.1124 19.1592 20.7177 20.6917 18.742C22.2242 16.7662 23.0379 14.3273 22.9986 11.8272C22.9594 9.32709 22.0695 6.91495 20.4756 4.98833",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9903 2.7743C17.2164 2.27173 16.3824 1.86854 15.5078 1.57422",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18V6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L12 18L17 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundDailyPointsInactive);
export default __webpack_public_path__ + "static/media/round-daily-points-inactive.d6d01e17b4c8455abec8ef43c7840342.svg";
export { ForwardRef as ReactComponent };